import StackAPI from '../../../lib/StackAPI'
import Storage from '../../../lib/Storage'
import { PartnerGeneralInfo } from '../types/PartnerGeneralInfo'
import { isEmpty } from '../../../utils/isEmpty'

const ENDPOINT = '/partners/vendors'

export const updateVendorGeneralInfo = async (data: PartnerGeneralInfo) => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return { error: 'no active role' }

  const { patch } = StackAPI()
  const { id } = role

  const params = {
    contact_info_attributes: {
      email: data.primaryContact,
      phone_number: data.phoneNumber,
      shipping_email_recipients: data.fulfillmentContact,
      support_contact_customers: data.supportContactCustomers,
      support_contact_stacksocial: data.supportContactStackCommerce,
      support_form_url: data.supportFormUrl
    }
  }

  const request = {
    path: `${ENDPOINT}/${id}`,
    params
  }

  return await patch(request)
    .then((response) => {
      if (response.status !== 200) {
        return { error: 'bad response' }
      }

      return response.data
    })
    .catch(() => ({ error: 'unknown error' }))
}
